import { render, staticRenderFns } from "./HbBaseInfo.vue?vue&type=template&id=48b39c31&scoped=true&"
import script from "./HbBaseInfo.vue?vue&type=script&lang=js&"
export * from "./HbBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./HbBaseInfo.vue?vue&type=style&index=0&id=48b39c31&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b39c31",
  null
  
)

export default component.exports